export default "__VITE_ASSET__BBQvfqvw__"